export const site_name = 'Sotraf';
export const logo = '/images/logo.jpg';

export const colors =
{
	primary: '#050D15',
	secondary: '#D5A021',
	primary_light: '#E9E9E9'
};

export const js_version = '1.0.4';

export const js_refresh_rate = { minutes: 30 }; // luxon Duration params

const config = { site_name, logo, colors, js_version, js_refresh_rate };

export const TIMEZONE = { zone: 'Europe/Paris' };

export default config;